/// <reference path="../../app.definition.ts" />
let $;
/*
* eCareVault.IOverlayService
*
* author: Ian Tripp
*/
import angular from "angular";
import * as SVG from "@common/utility/svg";
import * as HTMLUtil from "@common/utility/html";
import { NudgeElement, NudgeMessage } from "./nudge.service";
    const FRAME_HTML = `
        <div id="overlay-frame" class="overlay-frame">
            <div id="overlay-svg"></div>
            <div id="overlay-messages"></div>
            <div id="overlay-elements"></div>
        </div>"
    `;

    const MESSAGE_HTML = `
        <div class="overlay-message$CLASS"$STYLE>
            <div class="overlay-message-content">
                <span>$CONTENT</span>
            </div>
        </div>
    `;
    const SLE = 'window';

    export interface IOverlayService {
        setStage(elements: NudgeElement[], messages?: NudgeMessage[], scrollTo?: any): void;
        clearStage(): void;
        init(): void;
        show(): void;
        hide(): void;
        draw(): void;
        erase(nohide?: boolean, fullClear?: boolean): void;
        redraw(): void;
    }

    export class OverlayItem {
        relativeTo: ng.IAugmentedJQuery;
        selector: string;
        placement: string;
        offset: HTMLUtil.Offset;
        shift: HTMLUtil.Offset;
        size: HTMLUtil.ElementSize;
        padding: HTMLUtil.Sides;

        constructor(def: any) {
            this.deserialize(def, true);
        }

        deserialize(def: any, constr: boolean) {
            // console.log("Deserializing OverlayItem");
            this.relativeTo = def.relativeTo || angular.element('body');
            this.placement = def.placement || HTMLUtil.Placements.TOP;
            !!def.offset && (this.offset = def.offset);
            this.shift = def.shift || new HTMLUtil.Offset();
            !!def.size && (this.size = def.size);
            !!def.padding && (this.padding = def.padding);
            !!def.selector && (this.selector = def.selector);
        }
    }

    export class OverlayCutout extends OverlayItem {
        shapeGen: Function;
        shape: SVG.Shape;

        constructor(def: any) {
            super(def);
            this.deserialize(def, true);
        }

        deserialize(def: any, constr?: boolean) {
            // console.log("Deserializing OverlayCutout");
            super.deserialize(def, false);
            !!def.shapeGen && (this.shapeGen = def.shapeGen);
            this.placement = HTMLUtil.Placements.CENTER;
        }

        generateCutoutShape = (dir?: boolean): SVG.Shape => {
            if (!!this.shapeGen) {
                return this.shape = this.shapeGen(dir);
            }
            return this.shape = null;
        }
    }

    export class OverlayElement extends OverlayItem {
        definition: string;
        $el: JQuery<HTMLElement>;
        content: string;
        css: any;
        classAttr: string;

        constructor(def: any) {
            super(def);
            this.deserialize(def, true);
        }

        createElement(): JQuery<HTMLElement> {
            return this.$el;
        }

        place(compile?: Function, scope?: any): void {
            if (!!this.$el && !!this.$el[0]) {
                // console.log("RelativeTo:", this.relativeTo, "Element:", this.$el);
                let relElSize = HTMLUtil.elementSize(this.relativeTo);
                let relElOffset = HTMLUtil.getOffset(this.relativeTo);
                let msgElSize = this.size = new HTMLUtil.ElementSize((this.$el[0] as HTMLElement).offsetWidth, (this.$el[0] as HTMLElement).offsetHeight);
                let top: number = relElOffset.top + this.offset.top + this.shift.top;
                let left: number = relElOffset.left + this.offset.left + this.shift.left;

                switch (this.placement) {
                    case HTMLUtil.Placements.RIGHT:
                        top += (relElSize.outerHeight - msgElSize.outerHeight) / 2;
                        left += relElSize.outerWidth + 14;
                        break;
                    case HTMLUtil.Placements.LEFT:
                        top += (relElSize.outerHeight - msgElSize.outerHeight) / 2;
                        left -= msgElSize.outerWidth - 14;
                        break;
                    case HTMLUtil.Placements.BOTTOM:
                        top += relElSize.outerHeight + 14
                        left += (relElSize.outerWidth - msgElSize.outerWidth) / 2;
                        break;
                    case HTMLUtil.Placements.TOP:
                    default:
                        top -= msgElSize.outerHeight - 14;
                        left += (relElSize.outerWidth - msgElSize.outerWidth) / 2;
                        break;
                }

                this.offset = new HTMLUtil.Offset(left, top);
                // console.log("Placing message(", this.$el,msgElSize, this.offset, this.shift,") positioned to the",this.placement,"of", this.relativeTo,"(",relElSize, relElOffset,")")
                this.$el.css({ top: top, left: left });
                !!compile && !!scope && (compile(this.$el)(scope));

            }
        }

        deserialize(def: any, constr?: boolean) {
            // console.log("Deserializing OverlayElement");
            super.deserialize(def, false);
            !!def.definition && (this.definition = def.definition);
            !!def.content && (this.content = def.content);
            !!def.classAttr && (this.classAttr = def.classAttr);
            !!def.css && (this.css = def.css);
        }
    }

    export class OverlayMessage extends OverlayElement {


        constructor(def: any) {
            super(def);
            this.deserialize(def, true);
        }

        deserialize(def: any, constr?: boolean) {
            // console.log("Deserializing OverlayMessage");
            super.deserialize(def, false);
            this.createElement();
        }

        createElement(): JQuery<HTMLElement> {
            let str: string = this.content;

            this.definition = MESSAGE_HTML
                .replace("$CLASS", !!this.classAttr ? " " + this.classAttr : "")
                .replace("$STYLE", !!this.css ? " " + HTMLUtil.cssString(this.css) : "")
                .replace("$CONTENT", this.content || "");

            this.$el = angular.element(this.definition);
            return this.$el;
        }

        place(compile?: Function, scope?: any): void {
            super.place(compile, scope);

            let $arrow = angular.element(`<div class="message-arrow message-arrow-$DIR"></div>`.replace(/\$DIR/g, this.placement));
            this.$el.append($arrow);

        }

        addArrow(refElm): void {
            // we needs to move arrow to appropriate position only when it is placed at bottom or top
            const arrow = angular.element(`<div class="message-arrow message-arrow-$DIR" style="left:$LEFT"></div>`.replace(/\$DIR/g, this.placement));
            this.$el.remove('.message-arrow').append(arrow);
            if (this.placement == 'bottom' || this.placement == 'top') {
                let left = '50%';
                const refLeft = refElm.position().left;
                const refWidth = refElm.width();
                if ((refLeft + refWidth) != (this.$el.width() / 2)){
                    let leftPos = refLeft + (refWidth / 2) - this.$el.position().left;
                    left = leftPos + 'px';
                }
                arrow.css('left',left);//rewrite left position to appropriate place
            }
        }

    }

    /********************************************* NOT USED YET ***********************************************
    class OverlayService implements IOverlayService {
        private elementIds: string[];
        private redrawTimeout: ng.IPromise<any>;
        private nextRedraw: boolean;
        private frame: ng.IAugmentedJQuery;
        private elements: ng.IAugmentedJQuery;
        private messages: ng.IAugmentedJQuery;
        private svgCont: ng.IAugmentedJQuery;
        private svg: HTMLUtil.SVGElement;
        private objects: OverlayItem[];
        private active: boolean;
        private s: any;
        private scrollTop: number;
        private scrollTo: any;

        static $inject = ["$rootScope", "$compile", "$timeout", "ResizeService", "KeywordService"];
        constructor(
            private $rootScope: ng.IScope,
            private $compile: ng.ICompileService,
            private $timeout: ng.ITimeoutService,
            private $_resize: IResizeService,
            private $_keyw: IKeywordService
        ) {
            this.active = false;
        }

        setStage = (elements: NudgeElement[], messages?: NudgeMessage[], scrollTo?: any): void => {
            this.elementIds = elements.map(el => el.selector);
            this.elementIds.push('body');
            this.objects = [];

            !!scrollTo || scrollTo == 0 && (this.scrollTo = scrollTo);

            //Create the OverlayItem objects
            for (let element of elements || []) {
                element.loadElementInfo();
                this.objects.push(new OverlayCutout({
                    relativeTo: element.el,
                    selector: element.selector,
                    offset: !!element.offset ? new HTMLUtil.Offset(element.offset.left, element.offset.top) : new HTMLUtil.Offset(),
                    size: element.size,
                    padding: new HTMLUtil.Sides(element.padding.top, element.padding.right, element.padding.bottom, element.padding.left),
                    shapeGen: element.createShape
                }));
            }

            //Create the OverlayMessage objects
            for (let message of messages || []) {
                let relEl = angular.element(message.anchor);
                let relOff = HTMLUtil.getOffset(relEl);

                this.objects.push(new OverlayMessage({
                    relativeTo: relEl,
                    selector: message.anchor,
                    placement: message.location,
                    offset: !!message.distance ? new HTMLUtil.Offset(message.distance.left, message.distance.top) : new HTMLUtil.Offset(),
                    content: message.message,
                    shift: !!message.shift ? new HTMLUtil.Offset(message.shift.left, message.shift.top) : new HTMLUtil.Offset(),
                    classAttr: message.type
                }));
            }
        }

        clearStage = (): void => {
            this.elementIds = [];
            this.objects = []
        }

        private activateResizeWatchers = (): void => {
            this.$_resize.registerElements(this.elementIds, 1, false, 'overlay-redraw', 1, (event: string, el: ng.IAugmentedJQuery, ...args: any[]) => {
                // console.log('Redrawing Overlay');
                this.redraw(true);
            });
        }

        private deactivateResizeWatchers = (): void => {
            this.$_resize.unregisterElements(this.elementIds, 'overlay-redraw');
        }

        // Initialize the OverlayService
        init = (): void => {
            this.frame = angular.element(FRAME_HTML);
            this.messages = this.frame.find("#overlay-messages");
            this.elements = this.frame.find("#overlay-elements");
            this.svgCont = this.frame.find("#overlay-svg");

            this.initSVG();

            angular.element('body')
                .remove(".overlay-frame")
                .append(this.frame);
            this.hide();
        }

        initSVG = (): void => {
            this.svgCont.remove('#overlay-svg-object');
            this.svg = new HTMLUtil.SVGElement('overlay-svg-object', this.getBackgroundShape());
            this.svgCont.append(this.svg.getContainer());
        }

        getBackgroundShape = (): SVG.Shape => new SVG.Shape(SVG.Shapes.RECT, HTMLUtil.windowSize(), new HTMLUtil.Offset(), SVG.CLOCKWISE);

        show = (fn?: Function): void => {
            // HTMLUtil.saveEventHandlers($(window),'scroll');
            this.activateResizeWatchers();
            this.frame.fadeIn(250, fn);
        }

        hide = (fn?: Function): void => {
            this.deactivateResizeWatchers();
            HTMLUtil.resumeScroll('body');
            this.frame.fadeOut(500, fn);
        }

        setFrameSize = (size: HTMLUtil.ElementSize): void => {
            this.frame.css({ width: size.outerWidth, height: size.outerHeight });
        }

        draw = (noshow?: boolean): void => {
            this.active = true;
            this.scrollTop = 9999999;

            let currScroll = $(document).scrollTop();

            HTMLUtil.haltScroll('body'); //Do first to get accurate window size

            let win = HTMLUtil.windowSize();
            // console.log("Drawing Overlay on screen with size", win, 'and starting scroll', currScroll);

            this.setFrameSize(win);
            this.svg.setSize(win);
            this.svg.resetPath();

            //Draw the objects
            for (let oo of this.objects) {
                let elOffTop: number;
                let selector: string;
                if (oo instanceof OverlayCutout) {
                    //console.log('** Adding cutout to overlay:', oo);
                    if (oo.selector.indexOf(",") > -1) {
                        //console.log("Getting bounding box");
                        let els = oo.selector.split(",");
                        let bb = HTMLUtil.getBoundingBox(els, 'body');
                        //console.log("Els:", els, "BB:", bb);
                        oo.size = bb.size;
                        oo.offset = bb.offset;
                    } else {
                        oo.size = HTMLUtil.elementSize(oo.relativeTo);
                        oo.offset = HTMLUtil.getOffset(oo.relativeTo);
                    }
                    // oo.offset.top -= currScroll;
                    this.svg.addShape(oo.generateCutoutShape(SVG.COUNTER_CLOCKWISE));
                    elOffTop = oo.shape.offset.top;
                } else if (oo instanceof OverlayMessage) {
                    // console.log("** Adding message to overlay:", oo);
                    oo.content = this.$_keyw.replaceKeywords(oo.content, ['nudge']);
                    this.messages.append(oo.createElement());
                    this.$compile(oo.$el)(this.$rootScope);
                    // oo.offset.top -= currScroll;
                }

                if (oo instanceof OverlayMessage) {
                    this.$timeout(() => {
                        oo.place(null, this.$compile, this.$rootScope);
                        elOffTop = oo.offset.top;
                        elOffTop < this.scrollTop && (this.scrollTop = elOffTop);
                        //console.log("Element:", oo.selector, "Scroll Top:", this.scrollTop, "Element Top Offset:", elOffTop);
                    }, 100);

                } else {
                    elOffTop < this.scrollTop && (this.scrollTop = elOffTop);
                }

                //console.log("Element:", oo.selector, "Scroll Top:", this.scrollTop, "Element Top Offset:", elOffTop);
            }

            //console.log('Current scroll of', currScroll, 'is not set to', this.scrollTo);
            if (typeof this.scrollTo == 'number' && this.scrollTo != currScroll) {
                $(document).scrollTop(Math.min(0, this.scrollTop - 20)); //Change to (this.scrollTop - 20) when ready to deal with the page frame
            }

            this.$timeout(() => {
                this.svg.render();
                !!noshow || this.show(() => {
                    // console.log("OverlayService after draw(", noshow,"):", this, "$g", this.svg.getGroup());
                });
            }, 1);
        }

        erase = (nohide?: boolean, fullClear?: boolean): void => {
            if (!!this.active) {
                this.svg.resetPath();
                this.frame.find('#overlay-messages').children().remove();
                this.frame.find('#overlay-elements').children().remove();
                // this.frame.find('#overlay-svg-cont').children().remove();
                if (!!fullClear) {
                    this.objects = [];
                    this.elementIds = [];
                }
                this.active = false;
                this.$timeout(() => {
                    !!nohide || this.hide(this.svg.render);
                }, 1);
            }
            //
            // console.log("OverlayService after erase(", nohide,",", fullClear,"):", this, "$g", this.svg.getGroup());
        }

        // Destroy and rebuild the overlay
        redraw = (resize?: boolean): void => {
            if (!!this.redrawTimeout) {
                this.nextRedraw = true;
            } else {
                this.erase(true, false);
                if (!!resize) {

                }
                this.redrawTimeout = this.$timeout(() => {
                    if (this.nextRedraw) {
                        this.nextRedraw = false;
                        this.redraw();
                    }
                }, 250);
                this.draw(true);
            }
        }
    }

    angular.module('eCareVault.common.services')
        .service('OverlayService', OverlayService);

*******************************************/
